import '@styles/react/libs/tables/react-dataTable-component.scss';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCollection } from '../../../utility/hooks/useCollection';
import { setData, startLoadingTable } from '../../../redux/actions/list';
import { handleListFilter } from '../../../utility/helpers/handleFilter';
import { handleCleanForm } from '../../../redux/actions/form';
import { MiniTable } from '../datatable/MiniTable';
import { CDataTable } from '../datatable/DataTable';

export const ListInterpreter = ({
  title,
  endPoint,
  fakePoint,
  listOptions,
  listCollection = ['list', 'registers'],
  isSearchable = true,
  isClearable = true,
  isMini = false,
  isDemo = false,
  demoData = [],
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const state = useSelector((state) => state);
  const { getCollectionNode } = useCollection();
  const data = getCollectionNode(state, listCollection, false, false);
  const checkRows = getCollectionNode(
    state,
    ['list', 'checkRows'],
    false,
    false,
  );

  useEffect(() => {
    if (isSearchable && !isDemo)
      dispatch(
        startLoadingTable(
          endPoint,
          handleListFilter(listOptions?.filter, params),
          listOptions?.params,
          listOptions?.method,
        ),
      );
    if (isDemo) dispatch(setData(endPoint, demoData));
    if (isClearable) dispatch(handleCleanForm());
  }, [listOptions]);

  const ListComponent = isMini ? MiniTable : CDataTable;
  console.log(title, endPoint);
  return (
    <ListComponent
      title={title}
      data={data}
      checkRows={checkRows}
      endPoint={endPoint}
      fakePoint={fakePoint}
      listCollection={listCollection}
      {...listOptions}
      parentId={params.id}
    />
  );
};
